import {
  createInputFeature,
  ExtractFeaturePayload,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../Types';
import { dummyDispatch } from '../params/ParamFromSchema';

export const {
  actionCreator: setSchemaAction,
  selectorCreator: schemaSelector,
  featureReducer: SchemaFeature,
} = createInputFeature<'schema', SchemaType>('schema');

export type SchemaType = any;

export type SchemaState = {
  schema: {
    [inputId: string]: string;
  };
};

export type SchemaPayload = ExtractFeaturePayload<typeof setSchemaAction>;

export const reduceSchema =
  (payload: SchemaPayload) => (state: BridgeFormJSState) =>
    SchemaFeature(state, setSchemaAction(dummyDispatch)(payload));
